import {
  RE_SIZING_PLYWOOD_HISTORY_FAILED,
  RE_SIZING_PLYWOOD_HISTORY_REQUEST,
  RE_SIZING_PLYWOOD_HISTORY_SUCCESS,
} from "../../../../actions/Factory/ReSizingPlywood/reSizingPlywoodHistory/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const reSizingPlywoodHistoryReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case RE_SIZING_PLYWOOD_HISTORY_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case RE_SIZING_PLYWOOD_HISTORY_SUCCESS:
      // console.log("Payload received:", action.payload);

      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case RE_SIZING_PLYWOOD_HISTORY_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError,
          message,
        },
      };
    default:
      return state;
  }
};
